import { createActionGroup, props } from '@ngrx/store';
import { InstalledApplication } from '@rocksoft/locations-sdk';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const InstalledApplicationsResolverActions = createActionGroup({
  source: 'Installed Applications Resolver',
  events: {
    'Installed Applications requested': props<{ categoryId: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const InstalledApplicationsApiActions = createActionGroup({
  source: 'Installed Applications API',
  events: {
    'Installed Applications loaded': props<{ installedApplications: InstalledApplication[] }>(),
    'Installed Applications loaded error': props<{ error: ErrorModel }>(),
  },
});
